import {Injectable} from "@angular/core";
import {Provider} from "./model/providers";

@Injectable()
export class ProvidersHandler {
  constructor() {

  }

  public removeTempImages(map: mapboxgl.Map, providers: Provider[]) {
    for (let provider of providers) {
      if (provider.auxId && map.hasImage(provider.auxId)) {
        map.removeImage(provider.auxId);
      }
    }
  }

  public onProvidersReceive(map: mapboxgl.Map, providers: Provider[]) {
    if (providers.length) {
      const canvas = document.createElement('canvas');
      const size = 50; // Tamaño del canvas
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d', {willReadFrequently: true});


      for (const provider of providers) {
        if (map.hasImage(provider.id || provider.auxId) && provider.hasChanged) {
          map.removeImage(provider.id || provider.auxId);
        }
        const hasImage = map.hasImage(provider.id || provider.auxId);
        if (provider.base64Icon && !map.hasImage(provider.id || provider.auxId)) {
          const img = new Image();
          img.onload = () => {
            ctx.clearRect(0, 0, size, size);
            ctx.beginPath();
            ctx.arc(size / 2, size / 2, size / 2 - 2, 0, 2 * Math.PI);
            ctx.closePath();
            ctx.clip();
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, size, size);
            const imgAspectRatio = img.width / img.height;
            const canvasAspectRatio = size / size;

            let drawWidth = size;
            let drawHeight = size;
            let drawX = 0;
            let drawY = 0;
            if (imgAspectRatio > canvasAspectRatio) {
              drawHeight = size / imgAspectRatio;
              drawY = (size - drawHeight) / 2;
            } else {
              drawWidth = size * imgAspectRatio;
              drawX = (size - drawWidth) / 2;
            }

            ctx.drawImage(img, drawX, drawY, drawWidth, drawHeight);
            const imageData = canvas.toDataURL('image/png', 1.0);
            const finalImg = new Image();
            finalImg.crossOrigin = 'anonymous';
            finalImg.onload = () => {
              try {
                map.addImage(provider.id || provider.auxId, finalImg);
              } catch (error) {

              }
            };
            finalImg.src = imageData;
          };
          img.src = provider.base64Icon;
        } else {
          console.log("")
        }
      }
      //console.log('Received providers:', providers);
    }
  }
}
